
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqb0nWhHbRfTeoyOhyOLO65RqDWugFPEthglf3Uehm56AMeta } from "/codebuild/output/src1429799919/src/src/pages/faq.vue?macro=true";
import { default as menuB91gZGCKU1gKMx28amyG5M7RydUATuGU5kQvTBqPAU0Meta } from "/codebuild/output/src1429799919/src/src/pages/menu.vue?macro=true";
import { default as indexDpfnBsr9Wd4fFIZK4CoRqrnNFhe87nkaFiM8HzsBUk4Meta } from "/codebuild/output/src1429799919/src/src/pages/index.vue?macro=true";
import { default as contactK7hroL66VQ9MbdfHRxAwCoASPgR4ig0lA9T_fU7wLNkMeta } from "/codebuild/output/src1429799919/src/src/pages/contact.vue?macro=true";
import { default as tutorialHMlPuZSP4lriMJf2k2oKis7xovz0uVPvmiR_XPkhEFUMeta } from "/codebuild/output/src1429799919/src/src/pages/tutorial.vue?macro=true";
import { default as agreementN72sWhNx1XHu54kfCt8MrWply_45mgxXp1wQLC8_WIbjMMeta } from "/codebuild/output/src1429799919/src/src/pages/agreement.vue?macro=true";
import { default as about_45passLMlNA2o2HP5fuCHzR9S_45WAVF95mXPUZNCTZS_LulNTAMeta } from "/codebuild/output/src1429799919/src/src/pages/about-pass.vue?macro=true";
import { default as indexL7CVgzJ0EY0_i0IebAoh0305BVn9uG_VtNlmtvoOihYMeta } from "/codebuild/output/src1429799919/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93W5nTqO40ciYnxBfWkSAe9cAEmwt2Z7Ep_45Kiu72WIvRoMeta } from "/codebuild/output/src1429799919/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceOJB3PIVAGgl6b9ClTU1fuMzKKLCn9SW9CBGq6JKQ5TAMeta } from "/codebuild/output/src1429799919/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93lgoEe7s0PAi1Uu5i17qftP5hFeXSh3DG4S5EQXDX108Meta } from "/codebuild/output/src1429799919/src/src/pages/notice/[id].vue?macro=true";
import { default as indexHQqew_MLa1TFijc7nA7FuxjqZufKXi1BZnAqLvEebUkMeta } from "/codebuild/output/src1429799919/src/src/pages/coupon/index.vue?macro=true";
import { default as indexKcHA1ytYX43hh1JGy8w_KvsA6uv6XAvD1qytJxnJacAMeta } from "/codebuild/output/src1429799919/src/src/pages/mypage/index.vue?macro=true";
import { default as indexnNC9ia9wT5MEGBf6avVLAbGVCbNtT5EREBc700aMGzIMeta } from "/codebuild/output/src1429799919/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_931ckMesplivX5YRe4_45QLwvK1rxvIOJh6EPJ04aVUVImsMeta } from "/codebuild/output/src1429799919/src/src/pages/parking/[id].vue?macro=true";
import { default as indexTERHV5oicILCkcyglplYTQ93DxmhlAc9NDug_45dqY9EMMeta } from "/codebuild/output/src1429799919/src/src/pages/history/index.vue?macro=true";
import { default as indexcOcoJdvtH9wRNaonRNI1eRHlREhOxsHfuLzcnSzyFfwMeta } from "/codebuild/output/src1429799919/src/src/pages/monthly/index.vue?macro=true";
import { default as indexB8hKwFgx3vVXWpvmJhn1VQbzh0GXbF1lDRvxnVmFnEAMeta } from "/codebuild/output/src1429799919/src/src/pages/sign-in/index.vue?macro=true";
import { default as index_45xrWihDpDFJ4HYiZ9vt7MGeTQs4LG9i3ms_45ffqb19NIMeta } from "/codebuild/output/src1429799919/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavisZn00R5DCHcn6lX6zE7GmQN_9ARcZ_45i6SM1F6oRkxSoMeta } from "/codebuild/output/src1429799919/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit2NbwQhr9jMLgMabRbLcWzGj8JzWfhUpUf4X2FnngwjUMeta } from "/codebuild/output/src1429799919/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementOcGLp9H7YimjxB49QRFxaulMKTMco3KIoYj9heZW3a4Meta } from "/codebuild/output/src1429799919/src/src/pages/pass-agreement.vue?macro=true";
import { default as index4DwEuzFMiPMd6QnNHi06v0IaUhdHWWHHWSdfRhVhSG0Meta } from "/codebuild/output/src1429799919/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dbqiTEDhb98NpPnwFGXQEWxgeQEWQthT0hFdkK3QemgAMeta } from "/codebuild/output/src1429799919/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm31VoRxUlNnhwr8OeP8NOHq6Ou2IpWsyk22uBb9aajegMeta } from "/codebuild/output/src1429799919/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index7j1SOsuwHXCrWObmhCldXuPQ_Pf2LYd1ZNzq1uBVigEMeta } from "/codebuild/output/src1429799919/src/src/pages/card/create/index.vue?macro=true";
import { default as indexmQQT8_DRfxaqdTOPQre5BWEUnXJ3kWN6WmhwDuXUtlMMeta } from "/codebuild/output/src1429799919/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmSFPVd_9rCbHfnPjhMI_VEhObyCGA0MDiSBvxZ4V0PF8Meta } from "/codebuild/output/src1429799919/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirm7Ef3_45xA4R9CquKGqciIDbynYOrUre5GvT88o51w4w08Meta } from "/codebuild/output/src1429799919/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeGbAzPmjXKggimXrOMZ3LWLmKIzQOi6jyoheL_BHaHj4Meta } from "/codebuild/output/src1429799919/src/src/pages/membership/complete.vue?macro=true";
import { default as registerVlZU4anFU62hsChUTpqifYiN4aih4dy_45zt9nfuT774YMeta } from "/codebuild/output/src1429799919/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_939_oLAUtd7Exlo_45HElzbXHW8iL3CcMSCTYYt729zwod0Meta } from "/codebuild/output/src1429799919/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmFq1UpYREWm2F9wxrphQodqJNXSbW4TU3zgM3msc7_J0Meta } from "/codebuild/output/src1429799919/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_930KGOKrKQqJYGkdvgvzmlxkruvubwNnsDCXJ6SRKgwBwMeta } from "/codebuild/output/src1429799919/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexGDAoUVT6d1ChPBw2AO14DSMSF0MjwHlEEtYFbH4TF9IMeta } from "/codebuild/output/src1429799919/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codePBBachB8P2zrIEy2SL_45zKyGQhYCcqMtEUqCKVZRPgFoMeta } from "/codebuild/output/src1429799919/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeh9GdCNTZHuxadiQeseiAuxS62ObOpvZde70iAUaXPV0Meta } from "/codebuild/output/src1429799919/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeSG3ebntG74aDprx9_lggXehDgobt6reM74ZIOyA1DboMeta } from "/codebuild/output/src1429799919/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerujdVLJQmhY4_7OtTZYfKt3OGEz02PtXjQORaBuTqp7IMeta } from "/codebuild/output/src1429799919/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeq2voqj_vawlbCqn_0svj8hWEepSpbIeP5_45orLzKditIMeta } from "/codebuild/output/src1429799919/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexzMckULN_459EinpLWQP_8RMGpLFqMzQeVKL9ib6JZh3ysMeta } from "/codebuild/output/src1429799919/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmvJVHM0g70aitOL3pyZpCCBjZm3xZJ08G0tpsiYYcfAUMeta } from "/codebuild/output/src1429799919/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completebrAUVOeMmg71imwqGvAyhC_45a84jcDrYOxD1V0m7LolQMeta } from "/codebuild/output/src1429799919/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexZzfBN1U2Qv_45sTDYUAQ1Kjc07DkKPPUQK8K1nkkWbctcMeta } from "/codebuild/output/src1429799919/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_932NlCOn8oEGTrDhw66J004vVGgg7OW5MY1lFRGoLbkuoMeta } from "/codebuild/output/src1429799919/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete4i06KoS2VQfyeB1ffm_Uacp9luZENvEhxANkUDxt3NcMeta } from "/codebuild/output/src1429799919/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasTGoCTt8gvraYgXz2NwBZK67GiWqtdZMo0eXiioQFCC8Meta } from "/codebuild/output/src1429799919/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample6nHkrU9M2bgK_45peyk1qi341_45tolYdIRpX2HX1wvYREQMeta } from "/codebuild/output/src1429799919/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailumOxnI_456BDUen8pRsXcNy1vDprrangBHXd7ZW0x1VkgMeta } from "/codebuild/output/src1429799919/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmfYlPl5NEtDUqfTfAdL7GJF2LHR1JcetxAA5ntQkPBY4Meta } from "/codebuild/output/src1429799919/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentytHv1WkHHIw_4580YJA2L_ZSfowmDTFc_450Ei5ScKJz5wQMeta } from "/codebuild/output/src1429799919/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmShtVm5K83oLj4qQmXoIwwYpzLeJxyTpIZI6it0A_yU8Meta } from "/codebuild/output/src1429799919/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate762ia4YhMHWbDO6A9rckcO67gSbwGjL3GuyWyamBe1MMeta } from "/codebuild/output/src1429799919/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeP2T9ShCiWbTY2VonGrOffIejDr677_459_45V10ZeCYAUzMMeta } from "/codebuild/output/src1429799919/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeD42FI5pDUFamvkW4dEMmr6hPD0u2WNlf0tLNBSgkH0QMeta } from "/codebuild/output/src1429799919/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordwup7ti5l4SOtPvf4tPUO3vpvrA2RiYL2K5kIuG0ndmQMeta } from "/codebuild/output/src1429799919/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasLE16lbR_O8_7m23k32qm1rOKP81W5Lp39NQ6oMp_45ixoMeta } from "/codebuild/output/src1429799919/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registertnW5nEqWF8plsUJzEFCi7ZrFagYJIUyvOo9JrK21xQcMeta } from "/codebuild/output/src1429799919/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeaES0UeDYG73lzSjYmWLtzeialHTHKvmi8S5CXCSLqVIMeta } from "/codebuild/output/src1429799919/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexWYZq0TnDFPE_459MnEQlj51j4F7698mnSQ9Wldbc6J79sMeta } from "/codebuild/output/src1429799919/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indext9dXxdy6QB8bpKsozREavJcrNyzndE7emW5s_45_6vpFsMeta } from "/codebuild/output/src1429799919/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexgkMe7AfnFt7VVGnXI3or8RwVb28KC0I6b3L0rngLC30Meta } from "/codebuild/output/src1429799919/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexXcFEUQb5ZA25KxZj8QIxePSah60QpKAgvpL30SWsYtQMeta } from "/codebuild/output/src1429799919/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update3IeKHyuGgdoulhRNFpPiVgaIsKw4CZsAucCVrxy04VEMeta } from "/codebuild/output/src1429799919/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completepLhfybAmSlAncu5MufJzQuIpBWEQ2ykLSFg2nGLmlmsMeta } from "/codebuild/output/src1429799919/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmGGXI0X5R_45WaFka8_PV1_XDqDzAipG9A_LMbFSWlehLsMeta } from "/codebuild/output/src1429799919/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexaomM5sDJ5a5MIKHXj_452xY14AF_Et3GECzl81iit_ugIMeta } from "/codebuild/output/src1429799919/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeKFx1l0GrLVqrOmXx6F6IRua88iCOdNWBk0lJu6xTFzcMeta } from "/codebuild/output/src1429799919/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatetU4ecBt491rc0dFTmUd7kt2r76krZIAEqT_xY_eFPTYMeta } from "/codebuild/output/src1429799919/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexdxuxMzIc0IMKsQuKl0qEQc9ybqXuWYOcrLmRPtgjZnoMeta } from "/codebuild/output/src1429799919/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexjwrpVhwq65ZyzX_457swmdgnQmt5yuuti8pyjE7si_45RlEMeta } from "/codebuild/output/src1429799919/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeZ9Ii4NbCiQel1B_rqwkyFLg7qit2_45L4XIGvJGrbAP54Meta } from "/codebuild/output/src1429799919/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexFZQudcrgO5vb9OS34GBVKcyeXSM95PYS9DMNej9T5j4Meta } from "/codebuild/output/src1429799919/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codezdX378ErxcWQ_4558vQl9gx5ZVmg2GxeZm7Upu83YnE_UMeta } from "/codebuild/output/src1429799919/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indextEqNyQLgHq1_45K_y0LDC3NXfhndJYx9h1RvA8vZMs9MsMeta } from "/codebuild/output/src1429799919/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexeO9ZaSmh7z6wCnD8RwS_69QUQzWy4BiCgsXc1UGuU98Meta } from "/codebuild/output/src1429799919/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexjthMnNIq9WIZM_45_45TnlfxP_45l5TXgSRw3HhWI6uv9TQ_kMeta } from "/codebuild/output/src1429799919/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatewQyCRWAuFq_45EquT_45oYvwOpHbQdjeSb9Il4rudGsTZWkMeta } from "/codebuild/output/src1429799919/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmZmnn2AboWgA78McV02BnNrY6JjvcHLlQ6pGAXRy5Vz0Meta } from "/codebuild/output/src1429799919/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuB91gZGCKU1gKMx28amyG5M7RydUATuGU5kQvTBqPAU0Meta || {},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexDpfnBsr9Wd4fFIZK4CoRqrnNFhe87nkaFiM8HzsBUk4Meta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src1429799919/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexHQqew_MLa1TFijc7nA7FuxjqZufKXi1BZnAqLvEebUkMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1429799919/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexTERHV5oicILCkcyglplYTQ93DxmhlAc9NDug_45dqY9EMMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1429799919/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexB8hKwFgx3vVXWpvmJhn1VQbzh0GXbF1lDRvxnVmFnEAMeta || {},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: index_45xrWihDpDFJ4HYiZ9vt7MGeTQs4LG9i3ms_45ffqb19NIMeta || {},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index7j1SOsuwHXCrWObmhCldXuPQ_Pf2LYd1ZNzq1uBVigEMeta || {},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmSFPVd_9rCbHfnPjhMI_VEhObyCGA0MDiSBvxZ4V0PF8Meta || {},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirm7Ef3_45xA4R9CquKGqciIDbynYOrUre5GvT88o51w4w08Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1429799919/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeGbAzPmjXKggimXrOMZ3LWLmKIzQOi6jyoheL_BHaHj4Meta || {},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerVlZU4anFU62hsChUTpqifYiN4aih4dy_45zt9nfuT774YMeta || {},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmFq1UpYREWm2F9wxrphQodqJNXSbW4TU3zgM3msc7_J0Meta || {},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codePBBachB8P2zrIEy2SL_45zKyGQhYCcqMtEUqCKVZRPgFoMeta || {},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeh9GdCNTZHuxadiQeseiAuxS62ObOpvZde70iAUaXPV0Meta || {},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeSG3ebntG74aDprx9_lggXehDgobt6reM74ZIOyA1DboMeta || {},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerujdVLJQmhY4_7OtTZYfKt3OGEz02PtXjQORaBuTqp7IMeta || {},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmvJVHM0g70aitOL3pyZpCCBjZm3xZJ08G0tpsiYYcfAUMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completebrAUVOeMmg71imwqGvAyhC_45a84jcDrYOxD1V0m7LolQMeta || {},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexZzfBN1U2Qv_45sTDYUAQ1Kjc07DkKPPUQK8K1nkkWbctcMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete4i06KoS2VQfyeB1ffm_Uacp9luZENvEhxANkUDxt3NcMeta || {},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample6nHkrU9M2bgK_45peyk1qi341_45tolYdIRpX2HX1wvYREQMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailumOxnI_456BDUen8pRsXcNy1vDprrangBHXd7ZW0x1VkgMeta || {},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmfYlPl5NEtDUqfTfAdL7GJF2LHR1JcetxAA5ntQkPBY4Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentytHv1WkHHIw_4580YJA2L_ZSfowmDTFc_450Ei5ScKJz5wQMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmShtVm5K83oLj4qQmXoIwwYpzLeJxyTpIZI6it0A_yU8Meta || {},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeP2T9ShCiWbTY2VonGrOffIejDr677_459_45V10ZeCYAUzMMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeD42FI5pDUFamvkW4dEMmr6hPD0u2WNlf0tLNBSgkH0QMeta || {},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordwup7ti5l4SOtPvf4tPUO3vpvrA2RiYL2K5kIuG0ndmQMeta || {},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registertnW5nEqWF8plsUJzEFCi7ZrFagYJIUyvOo9JrK21xQcMeta || {},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeaES0UeDYG73lzSjYmWLtzeialHTHKvmi8S5CXCSLqVIMeta || {},
    component: () => import("/codebuild/output/src1429799919/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1429799919/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]